import { lazyLoad } from "utils/loadable";

const GamesPage = lazyLoad(
  () => import("./index"),
  (module) => module.GamesPage,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default GamesPage;
